import { render, staticRenderFns } from "./SlideWeather.vue?vue&type=template&id=a7a409c4&scoped=true&"
import script from "./SlideWeather.vue?vue&type=script&lang=js&"
export * from "./SlideWeather.vue?vue&type=script&lang=js&"
import style0 from "./SlideWeather.vue?vue&type=style&index=0&id=a7a409c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a409c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Typography: require('/opt/build/repo/components/Typography.vue').default})
